// extracted by mini-css-extract-plugin
module.exports = {"content":"commentary_decision_sources_modal-module__content--3onq6","link":"commentary_decision_sources_modal-module__link--1vASE"};